import React from 'react';
import type { DrawerProps } from '@mui/material';
import { Drawer as MuiDrawer, Box } from '@mui/material';

interface CustomDrawerProps extends DrawerProps {
  children: React.ReactNode;
  anchor?: 'left' | 'right' | 'top' | 'bottom';
  hideBackdrop?: boolean;
  variant?: 'permanent' | 'temporary' | 'persistent';
  miniWidth?: number;
  fullWidth?: number;
  miniVariant?: boolean;
  open?: boolean;
  onToggle?: () => void;
}

const Drawer: React.FC<CustomDrawerProps> = ({
  children,
  anchor = 'left',
  hideBackdrop = false,
  variant = 'permanent',
  miniWidth = 60,
  fullWidth = 250,
  miniVariant = false,
  open,
  onToggle,
  ...props
}) => {
  // ✅ Compute drawer width based on open state
  let drawerWidth = fullWidth;

  if (miniVariant) {
    drawerWidth = open ? fullWidth : miniWidth;
  }

  return (
    <MuiDrawer
      anchor={anchor}
      variant={variant}
      open={variant === 'permanent' ? true : open}
      hideBackdrop={hideBackdrop}
      onClose={onToggle}
      {...props}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        '& .MuiDrawer-paper': (theme) => ({
          width: drawerWidth,
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
        }),
        ...props.sx,
      }}
    >
      <Box
        sx={{
          width: drawerWidth,
          p: open ? 2 : 0,
          ...(open && { pl: '10px', pr: '10px' }),
        }}
      >
        {children}
      </Box>
    </MuiDrawer>
  );
};

export default Drawer;
